import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LandingPage } from './pages/LandingPage';
import { RegisterPage } from './pages/RegisterPage';
import { VoterDetailsPage } from './pages/VoterDetailsPage';
import { CastVotePage } from './pages/CastVotePage';
import { VerifyChoicesPage } from './pages/VerifyChoicesPage';
import { CompletedPage } from './pages/CompletedPage';
import { ResultsPage } from './pages/ResultsPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { VotingStatusErrorPage } from './pages/VotingStatusErrorPage';

export const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public & Voter Authentication */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Legacy Parity Error Pages */}
          <Route path="/error/votingnotstarted" element={<VotingStatusErrorPage />} />
          <Route path="/error/votingended" element={<VotingStatusErrorPage />} />
          <Route path="/error/youhavevoted" element={<VotingStatusErrorPage />} />
          <Route path="/error/notlogged" element={<VotingStatusErrorPage />} />

          {/* Voter Dashboard & Flow */}
          <Route path="/vote" element={<VoterDetailsPage />} />
          <Route path="/vote/cast-vote" element={<CastVotePage />} />
          <Route path="/vote/verify" element={<VerifyChoicesPage />} />
          <Route path="/vote/completed" element={<CompletedPage />} />

          {/* Live Results & Demographic Intelligence */}
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/results/demographics" element={<ResultsPage />} />
          <Route path="/results/analytics" element={<ResultsPage />} />
          <Route path="/result" element={<Navigate to="/results" replace />} />
          <Route path="/result/demographics" element={<Navigate to="/results/demographics" replace />} />
          <Route path="/demographics" element={<Navigate to="/results/demographics" replace />} />
          <Route path="/analytics" element={<Navigate to="/results/demographics" replace />} />

          {/* Admin Suite */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/analytics" element={<Navigate to="/admin/dashboard?tab=analytics" replace />} />
          <Route path="/admin/demographics" element={<Navigate to="/admin/dashboard?tab=analytics" replace />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};
